import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {Field, reduxForm} from 'redux-form';
import axios from 'axios';
import {
    NumberInput
} from 'admin-on-rest';
import {RESOURCES as locationResources} from '../fuseLocationsResourceMap';
import {getGetHeaders} from '../shared/functions';
import ProductTypeSelectInput from './ProductTypeSelectInput';
import ProductUnitsByTypeSelectInput from './ProductUnitsByTypeSelectInput';
import {viewStyles} from '../shared/styles-view';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import AddIcon from 'material-ui/svg-icons/content/add';
import CancelIcon from 'material-ui/svg-icons/navigation/close';

const defaultProductUnit = {
    brand: null,
    id: null,
    name: null,
    product_id: null,
    qty: 1,
    unit_qty: 1,
    unit_type: null
};

/**
 * A component for adding Product Units to Repacks / Retail Boxes.
 *
 */
class InventoryContentsTableAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addStatusDuplicate: '',
            addMessage: null,
            location: {
                city: null,
                dba: {
                    id: null,
                    name: null,
                    product_type: null
                },
                id: null,
                name: null,
                state: null
            },
            locationId: null,
            selectedQty: 1,
            selectedProductType: null,
            selectedProductUnit: defaultProductUnit,
            showAddForm: false
        };
    }

    componentWillMount() {
        const locationId = this.props.locationId;
        if (locationId && locationId !== '0000') {
            this.fetchLocationData(locationId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.addStatus !== this.props.addStatus ||
            nextProps.locationId !== this.props.locationId
        ) {
            let addMessage = null;
            if (nextProps.addStatus === 'duplicate') {
                addMessage = 'This Product Unit\'s Unit Type is already in the Contents. Adjust its Qty instead.';
            }
            if (nextProps.addStatus === 'error') {
                addMessage = 'This Product Unit could not be added.';
            }
            this.setState({
                addMessage: addMessage,
                locationId: nextProps.locationId
            });
        }
    }

    componentDidUpdate(prevProps) {
        const thisLocationid = this.props.locationId;
        if (prevProps.locationId !== thisLocationid) {
            if (thisLocationid && thisLocationid !== '0000') {
                this.fetchLocationData(thisLocationid);
            }
        }
    }

    /**
     * Get Location detail for DBA and Product Type
     *
     * @param locationId
     */
    fetchLocationData = (locationId) => {
        const defaultDba = {
            id: null,
            name: null,
            product_type: null
        };
        const params = {
            id: locationId
        };
        const resource = locationResources.Locations.GET_ONE(params);
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                const location = result.data.payload;
                const dba = (location && location.dba) ? location.dba : defaultDba;
                this.setState({
                    location: {
                        city: location.city,
                        dba: {
                            id: dba.id,
                            name: dba.name,
                            product_type: dba.product_type
                        },
                        id: location.id.toString(),
                        name: location.name,
                        state: location.state
                    },
                    selectedProductType: dba.product_type
                }, () => {
                    this.props.onLocation(location);
                });
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    };

    handleAddProductForm = () => {
        this.setState({
            addMessage: null,
            showAddForm: true
        });
    };

    handleAddProductCancel = () => {
        let resetProductUnit = JSON.parse(JSON.stringify(defaultProductUnit));
        this.setState({
            addMessage: null,
            selectedQty: 1,
            selectedProductUnit: resetProductUnit,
            showAddForm: false
        });
    };

    /**
     * Handle Product Type selection for addition (if no Location is available)
     *
     * @param productType
     */
    handleProductTypeSelect = (productType) => {
        if (productType) {
            this.setState({
                selectedProductType: productType.name
            });
        }
    };

    /**
     * Set Product Unit for addition
     *
     * @param productUnit
     */
    handleProductUnitSelect = (productUnit) => {
        let selectedProductUnit = JSON.parse(JSON.stringify(defaultProductUnit));
        if (productUnit) {
            selectedProductUnit.brand = productUnit.brand;
            selectedProductUnit.id = productUnit.id;
            selectedProductUnit.name = productUnit.name;
            selectedProductUnit.product_id = productUnit.product_id;
            selectedProductUnit.unit_type = productUnit.unit_type;
        }
        this.setState({
            selectedProductUnit: selectedProductUnit
        });
    };

    qtyValidation = (value) => {
        if (!value) {
            return 'Must be at least 1';
        }
        if (value <= 0) {
            return 'Must be at least 1';
        }
        return [];
    };

    validateChangeQty = [this.qtyValidation];

    handleChangeQty = (e, qty) => {
        this.setState({selectedQty: qty});
    };

    handleAddProductSubmit = () => {
        let selectedProductUnit = JSON.parse(JSON.stringify(this.state.selectedProductUnit));
        selectedProductUnit.qty = this.state.selectedQty;

        this.props.onAddProductUnit(selectedProductUnit);

        setTimeout(() => {
            let resetProductUnit = JSON.parse(JSON.stringify(defaultProductUnit));
            this.setState({
                selectedQty: 1,
                selectedProductUnit: resetProductUnit,
                showAddForm: false
            });
        }, 400);
    };

    render() {
        const {
            typeName
        } = this.props;

        const {
            addMessage,
            selectedProductType,
            selectedProductUnit,
            selectedQty,
            showAddForm,
        } = this.state;

        const styles = {
            formContainerHide: {display: 'none'},
            formContainerShow: {display: 'block'},
        };

        const formContainerStyle = (showAddForm)
            ? {...styles.formContainerShow, ...viewStyles.marginTop}
            : {...styles.formContainerHide, ...viewStyles.marginTop};

        let qtyIsValid = (selectedQty > 0 && !Number.isNaN(selectedQty) && selectedQty !== undefined);
        let addDisabled = (!selectedProductUnit.id || !qtyIsValid);

        return (
            <Fragment key="inventory-contents-table-add-container">

                {addMessage &&
                <p style={viewStyles.fieldInstructions}>{addMessage}</p>
                }

                {/* Button: Add Product (Form Toggle) */}
                {!showAddForm &&
                <RaisedButton
                    primary
                    label={`Add a Product to this ${typeName}`}
                    icon={<AddIcon/>}
                    onClick={this.handleAddProductForm}
                    style={viewStyles.marginTop}
                />
                }

                {/* Form: Add Product */}

                <div style={formContainerStyle}>

                    {/* Select Product Type (if none is available) */}

                    {!selectedProductType &&
                    <Fragment>
                        <p style={viewStyles.fieldInstructions}>
                            Please select a Product Type of the same Type as the items already in this {typeName}.
                            Selecting a different Product Type may cause inventory errors.
                        </p>
                        <ProductTypeSelectInput onSelectProductType={this.handleProductTypeSelect}/>
                    </Fragment>
                    }

                    {/* Select Product Unit by Product Type */}

                    {selectedProductType &&
                    <Fragment>
                        <p style={viewStyles.fieldInstructions}>
                            Select a Product Unit from {selectedProductType} and set the Quantity to add to
                            this {typeName}:
                        </p>
                        <ProductUnitsByTypeSelectInput
                            productType={selectedProductType}
                            onSelectProductUnit={this.handleProductUnitSelect}
                        />
                        <Field name="add_product_unit_qty"
                               label="Qty to Add"
                               component={NumberInput}
                               step={1}
                               validate={this.validateChangeQty}
                               onChange={this.handleChangeQty}
                               defaultValue={selectedQty}
                               value={selectedQty}
                        />
                    </Fragment>
                    }

                    <div style={viewStyles.marginTop}>
                        <RaisedButton
                            primary
                            label="Add Product"
                            icon={<AddIcon/>}
                            onClick={(e) => this.handleAddProductSubmit(e)}
                            style={viewStyles.marginRight}
                            disabled={addDisabled}
                        />
                        <FlatButton
                            primary
                            label="Cancel"
                            icon={<CancelIcon/>}
                            onClick={this.handleAddProductCancel}
                        />
                    </div>
                </div>
            </Fragment>
        )
    }
}

InventoryContentsTableAdd.propTypes = {
    addStatus: PropTypes.string,
    locationId: PropTypes.string,
    onAddProductUnit: PropTypes.func.isRequired,
    onLocation: PropTypes.func,
    typeName: PropTypes.string,
};

InventoryContentsTableAdd.defaultProps = {
    addStatus: null,
    locationId: '0000',
    typeName: 'Repack/Retail Box',
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'add-inventory-form',
        enableReinitialize: true,
    })
);

export default enhance(InventoryContentsTableAdd);



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryContentsTableAdd.js